import React, { useEffect, useMemo } from "react";
import { useTransition, animated, UseTransitionProps } from "@react-spring/web";

// Please consult with the team before adding any other variants
interface RevealProps {
  show: boolean;
  className?: string;
  type?: 'fade' | 'slide-up';
  config?: {
    distance?: number;
  }
  delay?: number;
  children: React.ReactNode;
}

const Reveal: React.FC<RevealProps> = ({ show, className, type = 'fade', children, config, delay }) => {

  const transistionConfig = useMemo<UseTransitionProps>(() => {
    const defaultConfig = {
      delay: delay || 0,
    };

    switch (type) {
      case 'slide-up': {
        const distance = `${config?.distance || 10}px`;
        return {
          ...defaultConfig,
          from: { transform: `translateY(${distance})`, opacity: 0 },
          enter: { transform: `translateY(0)`, opacity: 1 },
          leave: { transform: `translateY(-${distance})`, opacity: 0 },
        };
      }
      default:
        return {
          ...defaultConfig,
          from: { opacity: 0 },
          enter: { opacity: 1 },
          leave: { opacity: 0 },
        };
    }
  }, [type]);
  

  const transitions = useTransition(show, {
    ...transistionConfig,
  });

  useEffect(() => {
    //transitions.start();
  }, [show]);

  return transitions((style, item) => (item) && (
    <animated.div style={style} className={className}>
      {children}
    </animated.div>
  ))
};

export default Reveal;